import React from 'react';
import PropTypes from 'prop-types';
import Date from '~/modules/common/components/Date';

const DateReadOnly = ({ value }) => {
  return <Date component="Typography" value={value} />;
};

DateReadOnly.propTypes = {
  value: PropTypes.string
};

export default DateReadOnly;
